import axios from 'axios';
import Vue from 'vue';
import config from 'config';
/**
 *
 * @param {*Object} options
 * wfs要素查询，调用微服务gis模块接口
 */
async function wfsQueryFeature(options) {
  if (!config.project.baseRestUrlCatalog) throw Error('缺少必要参数！');
  let queryOptions = {
    method: 'post',
    url: `${config.project.baseRestUrlCatalog}/gis/wfs/getfeature`,
    data: options
  };
  const response = await axios(queryOptions).catch(err => {
    return err;
  });
  return response.data.data;
}

const api = {
  wfsQueryFeature
};

Vue.prototype.$api = api; // 可在.vue文件中直接使用 this.$api.wfsQueryFeature,调用接口
export default api;
